import { isIE } from 'react-device-detect';
/* eslint-disable */
/**
 * Takes a base64 encoded string and returns a url encoded string
 * by replacing the characters + and / with -, _ respectively,
 * and removing the = (fill) character.
 *
 * @param {String} input base64 encoded string.
 * @returns {String}
 */
function urlEncodeB64(input: string) {
  const b64Chars = { '+': '-', '/': '_', '=': '' };
  /* @ts-ignore */
  return input.replace(/[\+\/=]/g, (m) => b64Chars[m]);
}
/**
 * Takes an ArrayBuffer and convert it to Base64 url encoded string.
 * @param {ArrayBuffer} input
 * @returns {String}
 */
export function bufferToBase64UrlEncoded(input: ArrayBuffer) {
  var bytes = new Uint8Array(input);
  /* @ts-ignore */
  return urlEncodeB64(window.btoa(String.fromCharCode(...bytes)));
}
/**
 * Returns the sha256 digst of a given message.
 * This function is async.
 *
 * @param {String} message
 * @returns {Promise<ArrayBuffer>}
 */
export function sha256(message: string) {
  let encoder = new TextEncoder();
  let data = encoder.encode(message);
  // IE will return CryptoOperation instead promise
  if (isIE) {
    return new Promise<ArrayBuffer>((resolve, reject) => {
      const digest = window.crypto.subtle.digest('SHA-256', data);
      // @ts-ignore
      digest.oncomplete = function (event) {
        resolve(event.target.result);
      };
      // @ts-ignore
      digest.onerror = function (err) {
        reject(err);
      };
    });
  } else {
    return window.crypto.subtle.digest('SHA-256', data);
  }
}
